import { buildFormFieldErrorPayload } from '../buildPayloads/buildFormFieldErrorPayload.js';
export const trackFormFieldError = (params) => {
    return buildFormFieldErrorPayload(params);
};
//# sourceMappingURL=trackFormFieldError.js.map